export const saleRoutes = [
  {
    path: '/sale/listing',
    component: () => import('@/views/modules/sale/listing/listing'),
    meta: { name: 'Listing', keepAlive: true, permission: 'listing:view',modal:'销售'  }
  },
  {
    path: '/sale/saleOrder',
    component: () => import('@/views/modules/sale/saleOrder/sale-order'),
    meta: { name: '销售订单', keepAlive: true, permission: 'order:view' ,modal:'销售' }
  },
  {
    path: '/sale/promoteOrder',
    component: () => import('@/views/modules/sale/promote-order/promote-order'),
    meta: { name: '推广订单', keepAlive: true, permission: 'testOrder:view' ,modal:'销售' }
  },
  {
    path: '/sale/review',
    component: () => import('@/views/modules/sale/review/review'),
    meta: { name: 'Review', keepAlive: true, permission: 'review:view' ,modal:'销售' }
  },
  {
    path: '/sale/feedback',
    component: () => import('@/views/modules/sale/feedback/feedback'),
    meta: { name: 'Feedback', keepAlive: true, permission: 'feedback:view' ,modal:'销售' }
  },
  {
    path: '/sale/promotionAnalysis',
    component: () => import('@/views/modules/sale/promotion-analysis/promotion-analysis'),
    meta: { name: '促销分析', keepAlive: true,modal:'销售' }
  },
  {
    path: '/sale/amazonShipment',
    component: () => import('@/views/modules/sale/amazon-shipment/amazon-shipment'),
    meta: { name: '配送报告', keepAlive: true, permission: 'amazonShipment:view',modal:'销售'  }
  },
  {
    path: '/sale/customerReturn',
    component: () => import('@/views/modules/sale/customer-return/customer-return'),
    meta: { name: '退货订单', keepAlive: true, permission: 'customerReturn:view',modal:'销售'  }
  },
  {
    path: '/sale/removalShipment',
    component: () => import('@/views/modules/sale/removal-shipment/removal-shipment'),
    meta: { name: '移除报告', keepAlive: true, permission: 'removalShipment:view',modal:'销售'  }
  },
  {
    path: '/sale/replacementOrder',
    component: () => import('@/views/modules/sale/replacement-order/replacement-order'),
    meta: { name: '换货订单', keepAlive: true, permission: 'replacementOrder:view' ,modal:'销售' }
  },
  {
    path: '/sale/operation-log',
    component: () => import('@/views/modules/sale/operation-log/operation-log'),
    meta: { name: '运营日志', keepAlive: true, permission: 'operationLog:view' ,modal:'销售' }
  },
  {
    path: '/sale/calculate-profit-modal/:id',
    component: () => import('@/views/modules/sale/listing/components/calculate-profit-modal'),
    meta: { name: '试算利润', keepAlive: true,modal:'销售' }
  },
  {
    path: '/sale/upload-record',
    component: () => import('@/views/modules/sale/upload-record/upload-record'),
    meta: { name: '上传记录', keepAlive: true, permission: 'vatManage:edit', modal:'销售' }
  }
];
